// extracted by mini-css-extract-plugin
module.exports = {"topbar":"TopBar_topbar__jgCiU","logo":"TopBar_logo__1Y6Kn","navItem":"TopBar_navItem__1wPW3","navLink":"TopBar_navLink__hhFhJ","languageToggle":"TopBar_languageToggle__2w8Kc"};